import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import Spinners from "components/Common/Spinner";
import { Input } from "reactstrap";
import { setBreadcrumbItems } from "../../store/actions";
import { Row, Col, Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";
import * as url from "../../helpers/url_helper";

const AddNotification = (props) => {
  const [isLoading, setLoading] = useState(false);
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Add Notification", link: "#" },
  ];
  useEffect(() => {
    props.setBreadcrumbItems("Notification", breadcrumbItems);
  });
  const notification = {
    title: "",
    description: "",
    logo: "",
  };
  const [notificationDetails, setNotificationDetails] = useState(notification);
  async function CreateNotification(e) {
    let urlPath = "/send-notification";
    const isConfirmed = window.confirm(
      "Are you sure you want to send this notification to all?",
    );
    if (isConfirmed) {
      setLoading(true);
      const formData = new FormData();
      const token = localStorage.getItem("token");
      formData.append("title", notificationDetails.title);
      formData.append("description", notificationDetails.description);
      formData.append("bannerImage", notificationDetails.logo);
      fetch(url.GBN_URL + urlPath, {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then(async (responseData) => {
          if (responseData.status) {
            const result = responseData.result;
            window.location.href = "/Notification";
            toast.success("Notification Sent Successfully");
          }
        })
        .catch((error) => {
          console.log("err", error);
        })
        .finally((final) => {
          setLoading(false);
        });
    }
  }
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <>
          <Row>
            <Col xl="12">
              <Card>
                <CardHeader>
                  <div className="row align-items-center">
                    <div className="col d-flex justify-content-between align-items-center">
                      <CardTitle className="h4 mb-0">
                        Add Notification
                      </CardTitle>
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <div class="row">
                    <div className="col-lg-12">
                      <div
                        className="card card-custom gutter-b example example-compact"
                        style={{ borderRadius: "20px" }}
                      >
                        <div className="row" style={{ padding: "15px" }}>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label for="name">Title</label>
                              <Input
                                type="text"
                                className="form-control form-control-solid"
                                placeholder="Enter title"
                                maxLength={60}
                                onChange={(event) =>
                                  setNotificationDetails((prevState) => ({
                                    ...prevState,
                                    title: event.target.value,
                                  }))
                                }
                                value={notificationDetails.eventName}
                              />
                              <span className="form-text text-danger">
                                {notificationDetails.errors?.eventName}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label for="name">Logo</label>
                              <Input
                                type="file"
                                className="form-control form-control-solid"
                                placeholder="Enter description"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  setNotificationDetails((prevState) => ({
                                    ...prevState,
                                    logo: file,
                                  }));
                                }}
                                value={notificationDetails.eventName}
                              />
                              <small>
                                Supported formats: JPG, PNG, JPEG (Max size
                                150KB)
                              </small>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label for="name">Description</label>
                              <textarea
                                type="text"
                                maxLength={160}
                                className="form-control form-control-solid"
                                placeholder="Enter description"
                                onChange={(event) =>
                                  setNotificationDetails((prevState) => ({
                                    ...prevState,
                                    description: event.target.value,
                                  }))
                                }
                                value={notificationDetails.eventName}
                              />
                              <span className="form-text text-danger">
                                {notificationDetails.errors?.eventName}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <button
                              type="button"
                              onClick={(e) => CreateNotification()}
                              className="btn btn-primary me-3"
                            >
                              Save & Send All
                            </button>
                            <Link
                              to={"/Notification"}
                              className="btn btn-danger"
                            >
                              Cancel
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(AddNotification);
